import React, { useEffect } from 'react';
import {  Outlet, useLocation, useNavigate} from 'react-router-dom';
import DetailView from '../../Shared/DetailView';
import { Link } from 'react-router-dom';
import { Project } from '../../project/Project';
import Scroll from '../../Shared/Scroll/Scroll.js';
import { AppPages, UserRoles } from '../../project/Defines.js';

export default function TabStripRouter({state}) {
    let { pathname } = useLocation();
    const navigate = useNavigate(); 

    useEffect(() => {
        if(pathname?.endsWith(AppPages.Aquamed) && state.networkProjectTypes.aquamed === false) {
            const url =  Project.getPageUrl(state.r.page, AppPages.Thercodim) || "";
            navigate(url)
        }else if(pathname?.endsWith(AppPages.Thercodim) && state.networkProjectTypes.thercodim === false) {
            const url =  Project.getPageUrl(state.r.page, AppPages.Aquamed) || "";
            navigate(url)
        }
    },[state.networkProjectTypes, navigate, pathname, state.r.page])

    return <>
        {<DetailView>
                <React.Fragment>
						{state.r && state.r.subTabs && state.r.subTabs.length > 0 && 
                        <div className='tab_strip sub_pages'>
                            <wrap>
                                <Scroll>
                                <ul>
                                    {
                                        state.r.subTabs.map((subItem, i) => {
                                            const url =  Project.getPageUrl(state.r.page, subItem.page) || "";
                                            const selected = pathname?.endsWith(subItem.page);
                                            const filter = state.role === UserRoles.ADMIN ? state.networkProjectTypes[subItem.page] : state.r.page === AppPages.Version || state.r.page === AppPages.Statistics;
                                            return url && filter ? <>
                                                <li
                                                    key={i} // NOSONAR
                                                    className={selected ? "selected" : ""}>
                                                    
                                                    <Link to={url} ><text style={selected ? {color: "#4472c4"} : {}}>{subItem.text}</text></Link>
                                                </li>
                                            </> : <div
                                                    key={i} // NOSONAR
                                                    style={{ display: 'none' }}>
                                                </div >
                                        })
                                    }
                                </ul>
                                </Scroll>
                            </wrap>
                        </div>
						}
					</React.Fragment>
            <Outlet></Outlet>
        </DetailView>
        }
    </>
}